export default __webpack_public_path__ + "static/gatsby_TOC_sass_after-fe12651ba672bfd816b639d8b469154d.png";